import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessibilityStatementComponent } from './accessibility-statement/accessibility-statement.component';
import { JustonwebLoginComponent } from './justonweb-login/justonweb-login.component';
import { LoginComponent } from './login/login.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { DocumentComponent } from './document/document.component';

const routes: Routes = [
  // {
  //   path: '',
  //   component: LoginComponent
  // },
  {
    path: '',
    component: JustonwebLoginComponent
  },
  {
    path: 'document/:documentId',
    component: DocumentComponent
  },
  { 
    path: 'accessibility-statement', 
    component: AccessibilityStatementComponent 
  },
  { 
    path: 'privacy-policy', 
    component: PrivacyPolicyComponent
  },
  { 
    path: 'terms-of-use', 
    component: TermsOfUseComponent
  },
  { 
    path: 'help', 
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule) 
  },
  { 
    path: 'whats-new', 
    loadChildren: () => import('./whats-new/whats-new.module').then(m => m.WhatsNewModule) 
  },
  { 
    path: 'under-maintenance', 
    loadChildren: () => import('@justonweb/under-maintenance').then(m => m.UnderMaintenanceModule) 
  },
  {
    path: '**',
    redirectTo: '',
  } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {initialNavigation: 'enabledBlocking', enableTracing: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }